import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import useAccessLevels from '../hooks/use-access-levels';
import usePurchasingKeyController from '../hooks/use-purchasing-key';
import {createPanelEntries} from './catalog';
import type {PanelEntry} from './types';

/**
 * Builds the live PANEL_ENTRIES catalog from i18n + access levels.
 */
export const usePanelEntriesCatalog = (): PanelEntry[] => {
    const {packages} = useAccessLevels();
    // Key is loaded by PurchasingKeyProvider + sidebar; read only here to avoid duplicate fetches.
    const {purchasingKeyForPlanning} = usePurchasingKeyController({load: false});
    const {t: tSidebarDefault} = useTranslation('components', {keyPrefix: 'panel-sections.sidebar.default'});
    const {t: tSidebarCustomer} = useTranslation('components', {keyPrefix: 'panel-sections.sidebar.customer'});
    const {t: tSidebarVendor} = useTranslation('components', {keyPrefix: 'panel-sections.sidebar.vendor'});
    const {t: tCmdPages} = useTranslation('components', {keyPrefix: 'panel-sections.command-search.pages'});
    const {t: tCmdActions} = useTranslation('components', {keyPrefix: 'panel-sections.command-search.actions'});

    return useMemo(
        () => createPanelEntries({
            tSidebarDefault,
            tSidebarCustomer,
            tSidebarVendor,
            tCmdPages,
            tCmdActions,
            packages,
            purchasingKeyForPlanning,
        }),
        [tSidebarDefault, tSidebarCustomer, tSidebarVendor, tCmdPages, tCmdActions, packages, purchasingKeyForPlanning],
    );
};
